import { render, staticRenderFns } from "./SearchBoxv2.vue?vue&type=template&id=2c869ce5&scoped=true&"
import script from "./SearchBoxv2.vue?vue&type=script&lang=js&"
export * from "./SearchBoxv2.vue?vue&type=script&lang=js&"
import style0 from "./SearchBoxv2.vue?vue&type=style&index=0&id=2c869ce5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c869ce5",
  null
  
)

export default component.exports